<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Defect was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Defect - {{ this.defect.vehicle.registration }}</h1>
    <app-audit-line [data]='this.defect'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-workshop-defect-form [defect]='this.defect'></app-workshop-defect-form>

      @if (this.defect.id > 0) {
        <hr />
        <app-workshop-defect-fitters [workshopDefectId]='this.defect.id'></app-workshop-defect-fitters>
        <hr />
        <app-workshop-defect-parts [workshopDefectId]='this.defect.id'></app-workshop-defect-parts>
        <hr />
      }

      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/workshop/defects'>Cancel</button>
    </form>
  </div>
</div>
